/* Carrito lateral de Euphoria. Estado = /cart.js; los tramos por cantidad se cobran con descuentos automáticos de Shopify. */
(function () {
  'use strict';
  var CFG = window.elCartConfig || {};
  var T = CFG.texts || {};
  var root = document.getElementById('el-cart');
  if (!root) return;
  var els = { body: root.querySelector('[data-elc="body"]'), footer: root.querySelector('[data-elc="footer"]') };
  var R = CFG.routes || {};
  var state = { cart: null, open: false, couponOpen: false, couponMsg: '', error: '', upsellLoading: false, timerLeft: CFG.timerSeconds || 49 };
  var tieredIds = (CFG.tieredProducts || []).map(String);
  var tiers = (CFG.tiers || []).slice().sort(function (a, b) { return a.quantity - b.quantity; });
  var upsell = CFG.upsell && CFG.upsell.variantId ? CFG.upsell : null;
  var upsellVariant = upsell ? String(upsell.variantId) : null;
  var ICON = {
    check: '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6.5l2.5 2.5L10 3.5"/></svg>',
    bin: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>',
    tag: '<svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M5.5 3A2.5 2.5 0 003 5.5v2.879a2.5 2.5 0 00.732 1.767l6.5 6.5a2.5 2.5 0 003.536 0l2.878-2.878a2.5 2.5 0 000-3.536l-6.5-6.5A2.5 2.5 0 008.38 3H5.5zM6 7a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/></svg>',
    plus: '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M7 2v10M2 7h10"/></svg>',
    lock: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 018 0v4"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 8h12l1 13H5L6 8z"/><path d="M9 8V6a3 3 0 016 0v2"/></svg>'
  };

  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}', n = Math.round(cents) / 100, neg = n < 0; n = Math.abs(n);
    var amount = /amount_no_decimals/.test(fmt) ? Math.round(n).toLocaleString('en-US')
      : /amount_with_comma_separator/.test(fmt) ? n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var out = fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, amount).replace(/<[^>]+>/g, '');
    return neg ? '-' + out : out;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function tpl(s, vars) { return String(s || '').replace(/\[\[(\w+)\]\]/g, function (_, k) { return vars[k] != null ? vars[k] : ''; }); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function isTiered(i) { return tieredIds.indexOf(String(i.product_id)) !== -1; }
  function tierFor(q) { var t = null; tiers.forEach(function (x) { if (q >= x.quantity) t = x; }); return t; }
  function tierReward(i) { if (!isTiered(i)) return 0; var t = tierFor(i.quantity); return t ? t.reward * 100 : 0; }
  function compareAt(i) { var c = CFG.compareAt && CFG.compareAt[String(i.id)]; return c && c > i.original_price ? c : 0; }
  function couponApplied() { var c = state.cart && state.cart.discount_codes; return c && c.length && c[0].applicable ? c[0].code : ''; }
  function upsellInCart() { return !!(state.cart && state.cart.items.some(function (i) { return String(i.id) === upsellVariant; })); }
  function itemsVisible() { var items = state.cart ? state.cart.items : []; var o = items.filter(function (i) { return String(i.id) !== upsellVariant; }); return o.length ? o : items; }

  function totals() {
    var items = state.cart ? state.cart.items : [], subtotal = 0, cmp = 0, tier = 0;
    items.forEach(function (i) { subtotal += i.original_price * i.quantity; var c = compareAt(i); if (c) cmp += (c - i.original_price) * i.quantity; tier += tierReward(i); });
    var code = couponApplied();
    if (code) return { total: state.cart.total_price, savings: cmp + (subtotal - state.cart.total_price), code: code };
    return { total: subtotal - tier, savings: cmp + tier, code: '' };
  }

  function renderItem(item) {
    var reward = tierReward(item), c = compareAt(item), lineOriginal = item.original_price * item.quantity, lineNow = lineOriginal - reward;
    if (couponApplied()) { reward = 0; lineNow = item.final_line_price; }
    var del = c ? '<del>' + money(c * item.quantity) + '</del>' : (reward ? '<del>' + money(lineOriginal) + '</del>' : '');
    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="elc-item__variant">' + esc(item.variant_title) + '</div>' : '';
    var badge = reward ? '<div class="elc-tag">' + ICON.tag + tpl(T.tierBadge, { qty: item.quantity, amount: money(reward) }) + '</div>' : '';
    return '<div class="elc-item" data-key="' + esc(item.key) + '"><div class="elc-item__row">' +
      '<a class="elc-item__img" href="' + esc(item.url) + '" style="background-image:url(&quot;' + esc(img) + '&quot;)"></a>' +
      '<div class="elc-item__main"><div class="elc-item__top"><div><a class="elc-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant + '</div>' +
      '<button type="button" class="elc-remove" data-elc="remove" aria-label="Quitar">' + ICON.bin + '</button></div>' + badge +
      '<div class="elc-item__bottom"><div class="elc-price">' + del + money(lineNow) + '</div>' +
      '<div class="elc-qty"><button type="button" data-elc="qty" data-delta="-1" aria-label="Menos">−</button><span>' + item.quantity + '</span><button type="button" data-elc="qty" data-delta="1" aria-label="Más">+</button></div></div>' +
      '</div></div>' + (isTiered(item) && tiers.length ? renderTiers(item) : '') + '</div>';
  }
  function renderTiers(item) {
    var cur = tierFor(item.quantity), rows = [];
    function row(label, each, active, qty) {
      return '<button type="button" class="elc-tier" data-elc="tier" data-quantity="' + qty + '" data-active="' + active + '"><span class="elc-tier__check">' + ICON.check + '</span><span class="elc-tier__label">' + label + '</span><span>' + each + ' ' + esc(T.each) + '</span></button>';
    }
    if (!cur) rows.push(row(tpl(T.tierBase, { qty: 1 }), money(item.original_price), true, 1));
    tiers.forEach(function (t) {
      if (cur && t.quantity < cur.quantity) return;
      rows.push(row(tpl(T.tierRow, { qty: t.quantity, amount: money(t.reward * 100) }), money(item.original_price - (t.reward * 100) / t.quantity), !!cur && cur.quantity === t.quantity, t.quantity));
    });
    return '<div class="elc-tiers">' + rows.join('') + '</div>';
  }
  function renderBody() {
    if (!state.cart || !state.cart.item_count) {
      els.body.innerHTML = '<div class="elc-empty">' + ICON.bag + '<p>' + esc(T.empty) + '</p><span class="elc-link" data-elc="close">' + esc(T.continueShopping) + '</span></div>';
      els.footer.hidden = true; return;
    }
    els.body.innerHTML = itemsVisible().map(renderItem).join('');
    els.footer.hidden = false;
  }
  function timerHtml() { var m = Math.floor(state.timerLeft / 60), s = state.timerLeft % 60; return tpl(esc(T.timer), { timer: '<b>' + pad(m) + ':' + pad(s) + '</b>' }); }
  function renderFooter() {
    if (!state.cart || !state.cart.item_count) return;
    var t = totals(), h = '';
    if (state.error) h += '<div class="elc-coupon-msg">' + esc(state.error) + '</div>';
    h += '<div data-coupon-open="' + state.couponOpen + '"><button type="button" class="elc-coupon-toggle" data-elc="coupon-toggle">' + ICON.plus + (state.couponOpen ? esc(T.close) : esc(T.coupon)) + '</button>';
    if (state.couponOpen) {
      h += '<div class="elc-coupon-row"><div class="elc-coupon-field">' + (t.code
        ? '<span class="elc-chip">' + esc(t.code) + '<button type="button" data-elc="coupon-remove" aria-label="Quitar cupón">×</button></span>'
        : '<input type="text" data-elc="coupon-input" placeholder="' + esc(T.couponPlaceholder) + '" autocomplete="off">') +
        '</div><button type="button" class="elc-btn-secondary" data-elc="coupon-apply">' + esc(T.apply) + '</button></div>';
      if (t.code) h += '<div class="elc-coupon-msg">' + esc(T.overrides) + '</div>';
      else if (state.couponMsg) h += '<div class="elc-coupon-msg">' + esc(state.couponMsg) + '</div>';
    }
    h += '</div>';
    if (CFG.showTimer !== false) h += '<div class="elc-timer" data-elc="timer">' + timerHtml() + '</div>';
    if (t.savings > 0) h += '<div class="elc-savings"><span>' + esc(T.savings) + '</span><span>' + money(-t.savings) + '</span></div>';
    if (upsell) {
      var on = upsellInCart();
      h += '<div class="elc-upsell" data-elc="upsell" data-on="' + on + '" data-loading="' + state.upsellLoading + '"><span class="elc-upsell__box">' + ICON.check + '</span><span>' +
        tpl(esc(T.upsell), { title: '<b>' + esc(upsell.title) + '</b>', price: money(upsell.price) }) + '</span></div>';
    }
    h += '<div class="elc-total"><span>' + esc(T.total) + '</span><span>' + money(t.total) + '</span></div>';
    h += '<button type="button" class="elc-checkout" data-elc="checkout">' + ICON.lock + esc(T.checkout) + '</button>';
    if (T.badges) h += '<div class="elc-badges">' + ICON.lock + esc(T.badges) + '</div>';
    if (CFG.paymentIcons) h += '<div class="elc-payments">' + CFG.paymentIcons + '</div>';
    h += '<span class="elc-continue" data-elc="close">' + esc(T.continueShopping) + '</span>';
    els.footer.innerHTML = h;
  }
  function render() { renderBody(); renderFooter(); }

  setInterval(function () {
    state.timerLeft = state.timerLeft > 0 ? state.timerLeft - 1 : (CFG.timerSeconds || 49);
    var el = root.querySelector('[data-elc="timer"]'); if (el && state.open) el.innerHTML = timerHtml();
  }, 1000);

  function api(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); }); }
  function refresh() { return fetch((R.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { state.cart = c; render(); updateBubble(c); return c; }); }
  function setQuantity(key, qty) {
    els.body.setAttribute('data-loading', 'true'); state.error = '';
    return api((R.cartChange || '/cart/change') + '.js', { id: key, quantity: qty }).then(function (r) {
      if (r && r.status && r.status >= 400) state.error = r.description || r.message || 'No se pudo actualizar la cantidad';
      return refresh();
    }).finally(function () { els.body.removeAttribute('data-loading'); if (state.error) setTimeout(function () { state.error = ''; renderFooter(); }, 4000); });
  }
  function updateBubble(c) {
    document.querySelectorAll('.cart-bubble').forEach(function (b) {
      b.classList.toggle('visually-hidden', !c.item_count);
      var n = b.querySelector('.cart-bubble__text-count'); if (n) { n.textContent = c.item_count < 100 ? c.item_count : ''; n.classList.toggle('hidden', !c.item_count); }
    });
    document.querySelectorAll('.header-actions__cart-icon').forEach(function (i) { i.classList.toggle('header-actions__cart-icon--has-cart', !!c.item_count); });
  }
  function open() {
    if (state.open) { refresh(); return; }
    state.open = true; root.hidden = false; document.body.style.overflow = 'hidden';
    refresh().then(function () { setTimeout(function () { root.setAttribute('data-open', 'true'); }, 20); });
    setTimeout(function () { var h = document.querySelector('cart-drawer-component'); if (h && typeof h.close === 'function') { try { h.close(); } catch (e) {} } }, 400);
  }
  var onCartPage = location.pathname.replace(/\/$/, '') === (R.cart || '/cart');
  function close() {
    state.open = false; root.setAttribute('data-open', 'false'); document.body.style.overflow = '';
    setTimeout(function () { if (!state.open) root.hidden = true; }, 320);
    if (onCartPage) { var ref = document.referrer; window.location.href = ref && ref.indexOf(location.origin) === 0 && ref.indexOf('/cart') === -1 ? ref : '/'; }
  }
  window.elCart = { open: open, close: close, refresh: refresh };
  /* Botones de GemPages (el-product-button.js): si existe GPF.openCartDrawer lo usan en vez de ir a /cart */
  window.GPF = window.GPF || {}; window.GPF.openCartDrawer = function () { setTimeout(open, 50); };
  document.addEventListener('gp:open-cart-drawer', function () { setTimeout(open, 50); });
  /* Formularios enviados por script (form.submit no dispara 'submit'): vuelven a la misma página con el carrito abierto */
  var _submit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    if (isAdd(this.getAttribute('action') || '') && !this.querySelector('[name="return_to"]')) { var i = document.createElement('input'); i.type = 'hidden'; i.name = 'return_to'; i.value = location.pathname + '?cart=open'; this.appendChild(i); }
    return _submit.apply(this, arguments);
  };

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-elc]'); if (!t) return;
    var action = t.getAttribute('data-elc'), item = t.closest('.elc-item'), key = item && item.getAttribute('data-key');
    var line = key && state.cart.items.filter(function (i) { return i.key === key; })[0];
    switch (action) {
      case 'close': close(); break;
      case 'remove': if (line) setQuantity(key, 0); break;
      case 'qty': if (line) setQuantity(key, Math.max(0, line.quantity + parseInt(t.getAttribute('data-delta'), 10))); break;
      case 'tier': if (line && t.getAttribute('data-active') !== 'true') setQuantity(key, parseInt(t.getAttribute('data-quantity'), 10)); break;
      case 'coupon-toggle': state.couponOpen = !state.couponOpen; state.couponMsg = ''; renderFooter(); break;
      case 'coupon-apply': applyCoupon(); break;
      case 'coupon-remove': api((R.cartUpdate || '/cart/update') + '.js', { discount: '' }).then(function () { state.couponMsg = ''; return refresh(); }); break;
      case 'upsell': toggleUpsell(); break;
      case 'checkout': t.setAttribute('data-loading', 'true'); window.location.href = '/checkout'; break;
    }
  });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.getAttribute('data-elc') === 'coupon-input') { e.preventDefault(); applyCoupon(); }
    if (e.key === 'Escape') close();
  });
  function applyCoupon() {
    var input = root.querySelector('[data-elc="coupon-input"]'), code = input && input.value.trim(); if (!code) return;
    api((R.cartUpdate || '/cart/update') + '.js', { discount: code }).then(function (cart) {
      var found = (cart.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code.toUpperCase(); })[0];
      if (!found || !found.applicable) {
        var autoApplied = (cart.items || []).some(function (i) { return (i.line_level_discount_allocations || []).length > 0; });
        state.couponMsg = found && autoApplied ? T.notCombinable : T.invalid;
        return api((R.cartUpdate || '/cart/update') + '.js', { discount: '' });
      }
      state.couponMsg = '';
    }).then(refresh);
  }
  function toggleUpsell() {
    if (state.upsellLoading || !upsellVariant) return;
    state.upsellLoading = true; renderFooter();
    var existing = state.cart.items.filter(function (i) { return String(i.id) === upsellVariant; })[0];
    var p = existing ? api((R.cartChange || '/cart/change') + '.js', { id: existing.key, quantity: 0 }) : api((R.cartAdd || '/cart/add') + '.js', { items: [{ id: parseInt(upsellVariant, 10), quantity: 1 }] });
    p.then(refresh).finally(function () { state.upsellLoading = false; renderFooter(); });
  }

  /* Abre al agregar al carrito (cualquier formulario: Horizon o landings) y al pulsar el icono del carrito */
  function isAdd(url) { return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url); }
  var _fetch = window.fetch;
  window.fetch = function (input) { var url = typeof input === 'string' ? input : (input && input.url); var p = _fetch.apply(this, arguments); if (isAdd(url)) p.then(function (r) { if (r.ok) setTimeout(open, 50); }).catch(function () {}); return p; };
  var _xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) { if (isAdd(url)) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) setTimeout(open, 50); }); return _xo.apply(this, arguments); };
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="' + (R.cart || '/cart') + '"], a[href$="/cart"], .action__cart, [data-testid="cart-drawer-trigger"]');
    if (!a || a.closest('#el-cart')) return;
    e.preventDefault(); e.stopPropagation(); open();
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.tagName === 'FORM' && isAdd(f.getAttribute('action') || '') && !f.querySelector('[name="return_to"]')) {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = 'return_to'; i.value = location.pathname + '?cart=open'; f.appendChild(i);
    }
  }, true);
  if (/[?&]cart=open/.test(location.search)) { open(); history.replaceState(null, '', location.pathname); }
  else if (onCartPage) open();
  refresh();
})();
